import { render, staticRenderFns } from "./organism.modal.ugcSizeSelection.vue?vue&type=template&id=6bc4fdb8"
import script from "./organism.modal.ugcSizeSelection.vue?vue&type=script&lang=ts"
export * from "./organism.modal.ugcSizeSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports